const types = {
	//Get Template name
	GET_COMPLAIN_START: "GET_COMPLAIN_START",
	GET_COMPLAIN_SUCCESS: "GET_COMPLAIN_SUCCESS",
	GET_COMPLAIN_ERROR: "GET_COMPLAIN_ERROR",
	GET_COMPLAIN_RESET: "GET_COMPLAIN_RESET",

	//Create Template name
	CREATE_COMPLAIN_START: "CREATE_COMPLAIN_START",
	CREATE_COMPLAIN_SUCCESS: "CREATE_COMPLAIN_SUCCESS",
	CREATE_COMPLAIN_ERROR: "CREATE_COMPLAIN_ERROR",
	CREATE_COMPLAIN_RESET: "CREATE_COMPLAIN_RESET",

	//delete Template name
	DELETE_COMPLAIN_START: "DELETE_COMPLAIN_START",
	DELETE_COMPLAIN_SUCCESS: "DELETE_COMPLAIN_SUCCESS",
	DELETE_COMPLAIN_ERROR: "DELETE_COMPLAIN_ERROR",
	DELETE_COMPLAIN_RESET: "DELETE_COMPLAIN_RESET",

	//update Template name
	UPDATE_COMPLAIN_START: "UPDATE_COMPLAIN_START",
	UPDATE_COMPLAIN_SUCCESS: "UPDATE_COMPLAIN_SUCCESS",
	UPDATE_COMPLAIN_ERROR: "UPDATE_COMPLAIN_ERROR",
	UPDATE_COMPLAIN_RESET: "UPDATE_COMPLAIN_RESET",

	//single item  name
	SINGLE_COMPLAIN_START: "SINGLE_COMPLAIN_START",
	SINGLE_COMPLAIN_SUCCESS: "SINGLE_COMPLAIN_SUCCESS",
	SINGLE_COMPLAIN_ERROR: "SINGLE_COMPLAIN_ERROR",
	SINGLE_COMPLAIN_RESET: "SINGLE_COMPLAIN_RESET",
};

export default types;
